import ClientReporting from './ClientReporting';

export default ClientReporting;
